import React from 'react'
import './InputSelect.css'
import {Form} from "react-bootstrap";

class InputSelect extends React.Component {
    render() {
        return (
            <Form.Group>
                <Form.Label className={this.props.labelClasses}> {this.props.text} {this.props.showTextTooltip && <span className="availability-additional-text">{this.props.additionalText}</span>}</Form.Label>
                {this.props.children}
            </Form.Group>
        )
    }
}

export default InputSelect